import { SubmissionReviewViewModel } from '@program-suite/data-common/program';
import { Component, computed, inject, input, OnInit, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@program-suite/ui';
import { ViewSubmissionStore } from '@program-suite/data-common';
import { AuthStore } from '@program-suite/data-auth';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-submission-review',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './ui-submission-review.component.html',
  styleUrl: './ui-submission-review.component.scss',
})
export class SubmissionReviewComponent {
  authStore = inject(AuthStore);
  router = inject(Router);
  model = input.required<SubmissionReviewViewModel>();
  viewSubmissionStore = inject(ViewSubmissionStore);
  guid = input<string>();
  status = input<string>();

  closeModal = output<boolean>();

  // Older submissions predate field owners and carry payroll per class instead
  hasFieldOwners = computed(() => this.model().numberOfFieldOwners != null);

  get endorsements(): [string, string][] {
    return Object.entries(this.model().optionalCoverages ?? {});
  }

  downloadDocument(guid: string) {
    this.viewSubmissionStore.downloadDocument(guid);
  }

  manageSubmission() {
    this.router.navigate([`/quote/${this.guid()}`])
    this.viewSubmissionStore.setSubmissionReview(null);
    this.closeModal.emit(true);
  }
}
